import { updateGlobalEntities } from '.';
import { applyRule, verifyProductsRules } from '../../utils/rules';
import { selectProductsEntities, selectProductTypeAddOn } from '../selectors/bootstrap';
import { selectShoppingCartConfig } from '../selectors/shoppingCart';

/**
 * Handles rule enforcement
 *
 * @param {ruleType} Type of rule to apply
 * @param {ruleName} Name of rule
 * @param {productId} Product to check if it contains the rule
 * @returns {function(*, *): Promise}
 */
export const applyProductRules = ({ ruleType, ruleName, productId }) => {
  return (dispatch, getState) => {
    const shoppingCart = selectShoppingCartConfig(getState());
    const products = selectProductsEntities(getState());
    const addOns = selectProductTypeAddOn(getState());
    let addOnsToShow = shoppingCart?.addOnsToShow?.length > 0 ? shoppingCart?.addOnsToShow : addOns;
    const productsToApplyRule = verifyProductsRules(ruleType, ruleName, productId, products);
    addOnsToShow = productsToApplyRule ? applyRule(ruleName, productsToApplyRule, productId, addOnsToShow || products) : addOnsToShow;
    return dispatch(updateGlobalEntities({
      shoppingCart: {
        ...shoppingCart,
        addOnsToShow
      }
    }));
  };
};
